import axios from 'axios';
import React from 'react';
import Properties from "../const/Properties";
import CustomModal from "../thema/tema1/component/CustomModal";
import Footer from "../thema/tema1/component/Footer";
import Header from "../thema/tema1/component/Header";
import PageContext from "../thema/tema1/component/PageContext";
import SideMenu from "../thema/tema1/component/SideMenu";
import {withRouter} from 'react-router-dom';

const active = {Goruntule: "active"};
const durumlar = {
    1: "Araç Limana Giriş Yaptı",
    2: "Ek Bilgi Girişi Yapıldı",
    3: "Ücret Belirlendi",
    4: "Ücret Alındı",
    5: "Gemiye Yüklendi",
    6: "Muhasebe İşlmei Tamamlandı",
};
const gidecegiUlkeEnum = {
    0: "BELİRLENMEDİ",
    1: "TRİESTE",
    2: "BARİ",
};
const geldigiGumruk = {
    1: "ESENDERE",
    2: "DİLUCU",
    3: "GÜRBULAK",
};
class Goruntule extends React.Component {
    constructor(props) {
        super(props);
        //alert(this.props.match.params.id);
        this.state = {
            tasimaId: this.props.match.params.id,
            gemiUcreti: false,
            gemiUcretiOdeme: 0,
            gemiUcretiMuhasebe: 0,
            baf: false,
            bafOdeme: 0,
            bafMuhasebe: 0,
            ets: false,
            etsOdeme: 0,
            etsMuhasebe: 0,
            liman: false,
            limanOdeme: 0,
            limanMuhasebe: 0,
            soforUcreti: 0,
            soforUcretiOdeme: 0,
            soforUcretiMuhasebe: 0,
            ekSofor: 0,
            ekSoforOdeme: 0,
            ekSoforMuhasebe: 0,
            xray: false,
            xrayOdeme: 0,
            xrayMuhasebe: 0,
            yanici: false,
            yaniciOdeme: 0,
            yaniciMuhasebe: 0,
            rezervasyon: false,
            rezervasyonOdeme: 0,
            rezervasyonMuhasebe: 0,
            forklift: 0,
            forkliftOdeme: 0,
            forkliftMuhasebe: 0,
            ceza: 0,
            cezaOdeme: 0,
            cezaMuhasebe: 0,
            yolGecisUcreti: 0,
            yolGecisUcretiOdeme: 0,
            yolGecisUcretiSecim: "",
            yolGecisUcretiMuhasebe: 0,
            sigorta: 0,
            sigortaOdeme: 0,
            sigortaSecim: "",
            sigortaMuhasebe: 0,
            sigorta1ay: 0,
            sigorta2ay: 0,
            sigorta3ay: 0,
            gurbulak: 0,
            esendere: 0,
            dilucu: 0,
            toplam: 0,
            surucuAdi: "",
            karneNumarasi: "",
            pasaportNumarasi: "",
            geldigiGumruk: "",
            gemiAdi: "",
            muhurNumarasi: "",
            ttNumarasi: "",
            gidecegiUlke: "",
            kapAdeti: 0,
            kg: 0,
            yukCinsi: "",
            dorsePlaka: "",
            cekiciPlaka: "",
            firmaId: 0,
            tarih: "",
            durum: "",
            firmalar: [],
            content: [],
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            silModal: 'none',
            title: ["STATU", "TARİH", "ÇEKİCİ PLAKA", "İŞLEM ÜCRETİ", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.get();
        this.firmalarDoldur();

        console.log(this.state.firmalar);

    }

    componentDidMount() {
        this.firmalarDoldur();
        this.get();
        console.log(this.state.firmalar);
    }

    firmalarDoldur = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/firma/getAll',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let firmalar = [];
                for (let i = 0; i < res.data.length; i++) {
                    console.log(res.data[i]);
                    firmalar[res.data[i].id] = res.data[i].firmaAdi;
                }
                this.setState({firmalar: firmalar});
            })
    }
    geri = (e) => {
        window.location = document.referrer;
    }
    onChange = e => {
        this.setState({[e.target.name]: e.target.value});

        if (e.target.name === "sigorta") {
            this.setState({"sigortaSecim": e.target.options[e.target.selectedIndex].text});
        }
        if (e.target.name === "yolGecisUcreti") {
            this.setState({"yolGecisUcretiSecim": e.target.options[e.target.selectedIndex].text});
        }

        this.hesapla();
    }
    onChangeCheck = e => {
        console.log([e.target.name]);
        if (e.target.checked) {
            this.setState({[e.target.name]: 1});
        } else {
            this.setState({[e.target.name]: 0});
        }
        this.hesapla();
    }
    get = e => {
        let status = true;
        if (status) {

            axios({
                method: 'get',
                url: Properties.baseUrl + '/ucretbelirle/get/' + this.state.tasimaId,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            })
                .then(res => {
                    console.log(res.data);
                    this.setState({gemiUcreti: res.data.gemiUcreti});
                    this.setState({gemiUcretiOdeme: res.data.gemiUcretiOdeme});
                    this.setState({gemiUcretiMuhasebe: res.data.gemiUcretiMuhasebe});
                    this.setState({baf: res.data.baf});
                    this.setState({bafOdeme: res.data.bafOdeme});
                    this.setState({bafMuhasebe: res.data.bafMuhasebe});
                    this.setState({ets: res.data.ets});
                    this.setState({etsOdeme: res.data.etsOdeme});
                    this.setState({etsMuhasebe: res.data.etsMuhasebe});
                    this.setState({liman: res.data.liman});
                    this.setState({limanOdeme: res.data.limanOdeme});
                    this.setState({limanMuhasebe: res.data.limanMuhasebe});
                    this.setState({soforUcreti: res.data.soforUcreti});
                    this.setState({soforUcretiOdeme: res.data.soforUcretiOdeme});
                    this.setState({soforUcretiMuhasebe: res.data.soforUcretiMuhasebe});
                    this.setState({ekSofor: res.data.ekSofor});
                    this.setState({ekSoforOdeme: res.data.ekSoforOdeme});
                    this.setState({ekSoforMuhasebe: res.data.ekSoforMuhasebe});
                    this.setState({gidecegiUlke: res.data.gidecegiUlke});
                    this.setState({xray: res.data.xray});
                    this.setState({xrayOdeme: res.data.xrayOdeme});
                    this.setState({xrayMuhasebe: res.data.xrayMuhasebe});
                    this.setState({yanici: res.data.yanici});
                    this.setState({yaniciOdeme: res.data.yaniciOdeme});
                    this.setState({yaniciMuhasebe: res.data.yaniciMuhasebe});
                    this.setState({rezervasyon: res.data.rezervasyon});
                    this.setState({rezervasyonOdeme: res.data.rezervasyonOdeme});
                    this.setState({rezervasyonMuhasebe: res.data.rezervasyonMuhasebe});
                    this.setState({forklift: res.data.forklift});
                    this.setState({forkliftOdeme: res.data.forkliftOdeme});
                    this.setState({forkliftMuhasebe: res.data.forkliftMuhasebe});
                    this.setState({ceza: res.data.ceza});
                    this.setState({cezaOdeme: res.data.cezaOdeme});
                    this.setState({cezaMuhasebe: res.data.cezaMuhasebe});
                    this.setState({yolGecisUcreti: res.data.yolGecisUcreti});
                    this.setState({yolGecisUcretiOdeme: res.data.yolGecisUcretiOdeme});
                    this.setState({yolGecisUcretiMuhasebe: res.data.yolGecisUcretiMuhasebe});
                    this.setState({sigorta: res.data.sigorta});
                    this.setState({sigortaOdeme: res.data.sigortaOdeme});
                    this.setState({yolGecisUcretiMuhasebe: res.data.sigortaMuhasebe});
                    this.setState({yolGecisUcretiSecim: res.data.yolGecisUcretiSecim});
                    this.setState({sigortaSecim: res.data.sigortaSecim});


                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Ek Bilgi Güncellenemedi." : "Ek Bilgi Kaydedilemedi."));
            });
            axios({
                method: 'get',
                url: Properties.baseUrl + '/tasima/get/' + this.state.tasimaId,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            })
                .then(res => {
                    this.setState({surucuAdi: res.data.surucuAdi});
                    this.setState({karneNumarasi: res.data.karneNumarasi});
                    this.setState({pasaportNumarasi: res.data.pasaportNumarasi});
                    this.setState({geldigiGumruk: res.data.geldigiGumruk});
                    this.setState({gidecegiUlke: res.data.gidecegiUlke});
                    this.setState({muhurNumarasi: res.data.muhurNumarasi});
                    this.setState({ttNumarasi: res.data.ttNumarasi});
                    this.setState({gemiAdi: res.data.gemiAdi});
                    this.setState({yukCinsi: res.data.yukCinsi});
                    this.setState({kapAdeti: res.data.kapAdeti});
                    this.setState({kg: res.data.kg});
                    this.setState({cekiciPlaka: res.data.cekiciPlaka});
                    this.setState({dorsePlaka: res.data.dorsePlaka});
                    this.setState({gidecegiUlke: res.data.gidecegiUlke});
                    this.setState({tarih: res.data.tarih});
                    this.setState({ttNumarasi: res.data.ttNumarasi});
                    this.setState({durum: res.data.durum});
                    this.setState({firmaId: res.data.firmaId});
                    this.hesapla(res.data.gidecegiUlke);

                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Ek Bilgi Güncellenemedi." : "Ek Bilgi Kaydedilemedi."));
            });
        }
    }
    hesapla = e => {
        let gidecegiUlke = 0;
        if(e != undefined)
        {
            gidecegiUlke = e;
        }
        else{
            gidecegiUlke = this.state.gidecegiUlke;
        }
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tarife/get/'+gidecegiUlke,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let localToplam = 0;
                if (this.state.gemiUcreti) {
                    localToplam = localToplam + res.data.gemiUcretiTarife;
                    this.setState({gemiUcretiOdeme: res.data.gemiUcretiTarife});
                } else {
                    this.setState({gemiUcretiOdeme: 0});
                }
                if (this.state.baf) {
                    localToplam = localToplam + res.data.bafTarife;
                    this.setState({bafOdeme: res.data.bafTarife});
                } else {
                    this.setState({bafOdeme: 0});
                }
                if (this.state.ets) {
                    localToplam = localToplam + res.data.etsTarife;
                    this.setState({etsOdeme: res.data.etsTarife});
                } else {
                    this.setState({etsOdeme: 0});
                }
                if (this.state.liman) {
                    localToplam = localToplam + res.data.limanTarife;
                    this.setState({limanOdeme: res.data.limanTarife});
                } else {
                    this.setState({limanOdeme: 0});
                }
                if (this.state.xray) {
                    localToplam = localToplam + res.data.xrayTarife;
                    this.setState({xrayOdeme: res.data.xrayTarife});
                } else {
                    this.setState({xrayOdeme: 0});
                }
                if (this.state.yanici) {
                    localToplam = localToplam + res.data.yaniciTarife;
                    this.setState({yaniciOdeme: res.data.yaniciTarife});
                } else {
                    this.setState({yaniciOdeme: 0});
                }
                if (this.state.rezervasyon) {
                    localToplam = localToplam + res.data.rezervasyonTarife;
                    this.setState({rezervasyonOdeme: res.data.rezervasyonTarife});
                } else {
                    this.setState({rezervasyonOdeme: 0});
                }
                if (this.state.soforUcreti == 1) {
                    localToplam = localToplam + res.data.soforUcretiTarifeGemi;
                    this.setState({soforUcretiOdeme: res.data.soforUcretiTarifeGemi});
                } else if (this.state.soforUcreti == 2) {
                    localToplam = localToplam + res.data.soforUcretiTarifeUcak;
                    this.setState({soforUcretiOdeme: res.data.soforUcretiTarifeUcak});
                } else {
                    this.setState({soforUcretiOdeme: 0});
                }
                if (this.state.ekSofor == 1) {
                    localToplam = localToplam + res.data.ekSoforTarifeGemi;
                    this.setState({ekSoforOdeme: res.data.ekSoforTarifeGemi});
                } else if (this.state.ekSofor == 2) {
                    localToplam = localToplam + res.data.ekSoforTarifeUcak;
                    this.setState({ekSoforOdeme: res.data.ekSoforTarifeUcak});
                } else {
                    this.setState({ekSoforOdeme: 0});
                }

                localToplam = localToplam + parseInt(this.state.forklift);
                this.setState({forkliftOdeme: parseInt(this.state.forklift)});
                localToplam = localToplam + parseInt(this.state.ceza);
                this.setState({cezaOdeme: parseInt(this.state.ceza)});
                localToplam = localToplam + parseInt(this.state.yolGecisUcreti);
                this.setState({yolGecisUcretiOdeme: parseInt(this.state.yolGecisUcreti)});
                localToplam = localToplam + parseInt(this.state.sigorta);
                this.setState({sigortaOdeme: parseInt(this.state.sigorta)});
                this.setState({toplam: localToplam});
            }).catch(res => {
            window.unsuccessful((this.state.showDuzenle ? "Ücret Belirle  Güncellenemedi." : "Ücret Belirle  Kaydedilemedi."));
        });
    }
     handlePrint = () => {
        const printContent = document.getElementById("print").innerHTML;
        const popupWin = window.open('', '_blank');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
         <!-- Google Font: Source Sans Pro -->
    <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback">
    <!-- Font Awesome -->
    <link rel="stylesheet" href="/thema/tema1/plugins/fontawesome-free/css/all.min.css">
    <!-- Ionicons -->
    <link rel="stylesheet" href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css">
    <!-- Tempusdominus Bootstrap 4 -->
    <link rel="stylesheet" href="/thema/tema1/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css">
    <!-- iCheck -->
    <link rel="stylesheet" href="/thema/tema1/plugins/icheck-bootstrap/icheck-bootstrap.min.css">
    <!-- JQVMap -->
    <link rel="stylesheet" href="/thema/tema1/plugins/jqvmap/jqvmap.min.css">
    <!-- Theme style -->
    <link rel="stylesheet" href="/thema/tema1/dist/css/adminlte.min.css">
    <!-- overlayScrollbars -->
    <link rel="stylesheet" href="/thema/tema1/plugins/overlayScrollbars/css/OverlayScrollbars.min.css">
    <!-- Daterange picker -->
    <link rel="stylesheet" href="/thema/tema1/plugins/daterangepicker/daterangepicker.css">
    <!-- summernote -->
    <link rel="stylesheet" href="/thema/tema1/plugins/summernote/summernote-bs4.min.css">
    <link rel="stylesheet" href="/thema/tema1/plugins/datatables-bs4/css/dataTables.bootstrap4.min.css">
    <link rel="stylesheet" href="/thema/tema1/plugins/datatables-responsive/css/responsive.bootstrap4.min.css">
    <link rel="stylesheet" href="/thema/tema1/plugins/datatables-buttons/css/buttons.bootstrap4.min.css">
    <!-- summernote -->
    <link rel="stylesheet" href="/thema/tema1/plugins/summernote/summernote-bs4.min.css">
    <!-- CodeMirror -->
    <link rel="stylesheet" href="/thema/tema1/plugins/codemirror/codemirror.css">
    <link rel="stylesheet" href="/thema/tema1/plugins/codemirror/theme/monokai.css">
    <link rel="stylesheet" href="/thema/tema1/plugins/toastr/toastr.min.css">
        <head>
          <title>Print</title>
        </head>
        <body onload="window.print();">${printContent}</body>
         <script src="/thema/tema1/plugins/jquery/jquery.min.js"></script>
  <script src="/thema/tema1/plugins/datatables/jquery.dataTables.min.js"></script>
  <script src="/thema/tema1/plugins/jqvmap/maps/jquery.vmap.usa.js"></script>
  <!-- jQuery UI 1.11.4 -->
  <script src="/thema/tema1/plugins/jquery-ui/jquery-ui.min.js"></script>
  <!-- Bootstrap 4 -->
  <script src="/thema/tema1/plugins/bootstrap/js/bootstrap.bundle.min.js"></script>
  <!-- ChartJS -->
  <script src="/thema/tema1/plugins/chart.js/Chart.min.js"></script>
  <!-- Sparkline -->
  <script src="/thema/tema1/plugins/sparklines/sparkline.js"></script>
  <!-- JQVMap -->
  <script src="/thema/tema1/plugins/jqvmap/jquery.vmap.min.js"></script>
  <!-- jQuery Knob Chart -->
  <script src="/thema/tema1/plugins/jquery-knob/jquery.knob.min.js"></script>
  <!-- daterangepicker -->
  <script src="/thema/tema1/plugins/moment/moment.min.js"></script>
  <script src="/thema/tema1/plugins/daterangepicker/daterangepicker.js"></script>
  <!-- Tempusdominus Bootstrap 4 -->
  <script src="/thema/tema1/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.min.js"></script>
  <!-- Summernote -->
  <script src="/thema/tema1/plugins/summernote/summernote-bs4.min.js"></script>
  <!-- overlayScrollbars -->
  <script src="/thema/tema1/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js"></script>
  <!-- AdminLTE App -->
  <script src="/thema/tema1/dist/js/adminlte.js"></script>
  <!-- AdminLTE for demo purposes -->
  <script src="/thema/tema1/dist/js/demo.js"></script>
  <!-- AdminLTE dashboard demo (This is only for demo purposes) -->
  <script src="/thema/tema1/dist/js/pages/dashboard.js"></script>
  <script src="/thema/tema1/plugins/datatables/jquery.dataTables.min.js"></script>
  <script src="/thema/tema1/plugins/datatables-bs4/js/dataTables.bootstrap4.min.js"></script>
  <script src="/thema/tema1/plugins/datatables-responsive/js/dataTables.responsive.min.js"></script>
  <script src="/thema/tema1/plugins/datatables-responsive/js/responsive.bootstrap4.min.js"></script>
  <script src="/thema/tema1/plugins/datatables-buttons/js/dataTables.buttons.min.js"></script>
  <script src="/thema/tema1/plugins/datatables-buttons/js/buttons.bootstrap4.min.js"></script>
  <script src="/thema/tema1/plugins/datatables-buttons/js/buttons.html5.min.js"></script>
  <script src="/thema/tema1/plugins/datatables-buttons/js/buttons.print.min.js"></script>
  <script src="/thema/tema1/plugins/datatables-buttons/js/buttons.colVis.min.js"></script>
  <script src="/thema/tema1/plugins/jszip/jszip.min.js"></script>
  <script src="/thema/tema1/plugins/pdfmake/pdfmake.min.js"></script>
  <script src="/thema/tema1/plugins/toastr/toastr.min.js"></script>
  <script src="/thema/tema1/plugins/pdfmake/vfs_fonts.js"></script>
  <!-- InputMask -->
<script src="/thema/tema1/plugins/moment/moment.min.js"></script>
<script src="/thema/tema1/plugins/inputmask/jquery.inputmask.min.js"></script>
  <!-- Summernote -->
  <script src="/thema/tema1/plugins/summernote/summernote-bs4.min.js"></script>
  <!-- CodeMirror -->
  <script src="/thema/tema1/plugins/codemirror/codemirror.js"></script>
  <script src="/thema/tema1/plugins/codemirror/mode/css/css.js"></script>
  <script src="/thema/tema1/plugins/codemirror/mode/xml/xml.js"></script>
  <script src="/thema/tema1/plugins/codemirror/mode/htmlmixed/htmlmixed.js"></script>
  <script src="/thema/tema1/plugins/custom/toastmessage.js"></script>
  <script src="/thema/tema1/plugins/custom/datepickerrun.js"></script>
      </html>
    `);
        popupWin.document.close();
    };
    render() {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu/>
                <PageContext>
                    <form>
                        <div className="card card-primary" id="print">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-2">
                                        <h3 className="card-title">Görüntüle</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row" style={{"margin": "20px"}}>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Statu
                                            <div style={{"font-weight": "normal"}}> {durumlar[this.state.durum]}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Çekici
                                            Plaka
                                            <div style={{"font-weight": "normal"}}> {this.state.cekiciPlaka}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Dorse
                                            Plaka
                                            <div style={{"font-weight": "normal"}}> {this.state.dorsePlaka}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Firma
                                            <div
                                                style={{"font-weight": "normal"}}> {this.state.firmalar[this.state.firmaId]}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Tarih
                                            <div style={{"font-weight": "normal"}}> {this.state.tarih}</div>
                                        </label>
                                    </div>
                                </div>
                                <div className="row">

                                </div>
                                <div className="row" style={{"margin": "20px"}}>

                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">TT
                                            Numarası <div
                                                style={{"font-weight": "normal"}}> {this.state.ttNumarasi}</div></label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Surucu Adi <div
                                            style={{"font-weight": "normal"}}> {this.state.surucuAdi}</div></label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Karne
                                            Numarasi <div
                                                style={{"font-weight": "normal"}}> {this.state.karneNumarasi}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Pasaport
                                            Numarasi <div
                                                style={{"font-weight": "normal"}}> {this.state.pasaportNumarasi}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Geldigi
                                            Gumruk: <div
                                                style={{"font-weight": "normal"}}>{geldigiGumruk[this.state.geldigiGumruk]}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Gidecegi
                                            Ulke
                                            <div
                                                style={{"font-weight": "normal"}}> {gidecegiUlkeEnum[this.state.gidecegiUlke]}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Gemi Adi
                                            <div style={{"font-weight": "normal"}}> {this.state.gemiAdi}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Yük Cinsi
                                            <div style={{"font-weight": "normal"}}> {this.state.yukCinsi}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">Kap Adeti
                                            <div style={{"font-weight": "normal"}}> {this.state.kapAdeti}</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label
                                            htmlFor="exampleInputPassword1">kg
                                            <div style={{"font-weight": "normal"}}> {this.state.kg} kg</div>
                                        </label>
                                    </div>
                                </div>
                                <div className="row" style={{"margin": "20px","display":"none"}}>
                                    <div style={{"display": "none"}}>
                                        <div className="col-3">
                                            <label htmlFor="exampleInputPassword1">Gemi Ucreti
                                                <div
                                                    style={{"font-weight": "normal"}}> {this.state.gemiUcretiOdeme} €</div>
                                            </label>
                                        </div>
                                        <div className="col-3">
                                            <label htmlFor="exampleInputPassword1">ETS Ucreti
                                                <div style={{"font-weight": "normal"}}> {this.state.etsOdeme} €</div>
                                            </label>
                                        </div>
                                        <div className="col-3">
                                            <label htmlFor="exampleInputPassword1">Liman Ucreti
                                                <div style={{"font-weight": "normal"}}> {this.state.limanOdeme} €</div>
                                            </label>
                                        </div>
                                        <div className="col-3">
                                            <label htmlFor="exampleInputPassword1">Şoför Ucreti
                                                <div style={{"font-weight": "normal"}}> {this.state.soforUcretiOdeme} €
                                                </div>
                                            </label>
                                        </div>

                                        <div className="col-3">
                                            <label htmlFor="exampleInputPassword1">XRAY Ucreti
                                                <div style={{"font-weight": "normal"}}> {this.state.xrayOdeme} €</div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-3"
                                         style={this.state.soforUcreti === 1 ? {"display": "Block"} : {"display": "None"}}>
                                        <label htmlFor="exampleInputPassword1">GEMİ ÜCRETİ KABİN
                                            <div
                                                style={{"font-weight": "normal"}}> {this.state.gemiUcretiOdeme + this.state.etsOdeme+ this.state.bafOdeme + this.state.limanOdeme + this.state.soforUcretiOdeme + this.state.xrayOdeme} €</div>
                                        </label>
                                    </div>
                                    <div className="col-3"
                                         style={this.state.soforUcreti === 2 ? {"display": "Block"} : {"display": "None"}}>
                                        <label htmlFor="exampleInputPassword1">GEMİ ÜCRETİ UÇAK
                                            <div
                                                style={{"font-weight": "normal"}}> {this.state.gemiUcretiOdeme + this.state.etsOdeme  + this.state.bafOdeme + this.state.limanOdeme + this.state.soforUcretiOdeme + this.state.xrayOdeme} €</div>
                                        </label>
                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Ek Şoför Ucreti
                                            <div style={{"font-weight": "normal"}}> {this.state.ekSoforOdeme} €</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Yanıcı Ucreti
                                            <div style={{"font-weight": "normal"}}> {this.state.yaniciOdeme} €</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Rezervasyon Ucreti
                                            <div style={{"font-weight": "normal"}}> {this.state.rezervasyonOdeme} €
                                            </div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Forklift Ucreti
                                            <div style={{"font-weight": "normal"}}> {this.state.forkliftOdeme} €</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Ceza Ucreti
                                            <div style={{"font-weight": "normal"}}> {this.state.cezaOdeme} €</div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Yol Geçiş Ucreti
                                            <div
                                                style={{"font-weight": "normal"}}> {this.state.yolGecisUcretiSecim !== null ? this.state.yolGecisUcretiSecim + " - " : this.state.yolGecisUcretiSecim}{this.state.yolGecisUcretiOdeme} €
                                            </div>
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputPassword1">Sigorta Ucreti
                                            <div
                                                style={{"font-weight": "normal"}}> {this.state.sigortaSecim !== null ? this.state.sigortaSecim + " - " : this.state.sigortaSecim}{this.state.sigortaOdeme} €
                                            </div>
                                        </label>
                                    </div>
                                </div>
                                <div className="row" style={{"margin": "20px","display":"none"}}>
                                    <div className="col-3" style={{"margin": "20px","display":"none"}}>
                                        <label htmlFor="exampleInputPassword1">TOPLAM: {this.state.toplam} €</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="card-footer row">
                            <div className="col-1">
                                <button type="button" onClick={e => this.handlePrint(e)}
                                        className="btn btn-block btn-outline-info">ÇIKTI AL
                                </button>
                            </div>
                            <div className="col-1">
                                <button type="button" onClick={e => this.geri(e)}
                                        className="btn btn-block btn-outline-info">GERİ
                                </button>
                            </div>
                        </div>
                    </form>
                </PageContext>
                <Footer/>
                <CustomModal id={"modal-default"} funcModal={this.ucretBelirleSave} title={"Ücret Belirle  Girişi"}
                             content={"Ücret Belirle leri Onaylıyor Musunuz?"}></CustomModal>

            </div>);
    }
}


export default withRouter(Goruntule);
